import { ref, onMounted } from 'vue';
import type { Ref } from 'vue';
import apiEntries from '@/api';
import type {RiskProfileOptions} from '@/types/risk-profile-options';

const options: Ref<RiskProfileOptions | null> = ref(null);
const loading: Ref<boolean> = ref(false);
const error: Ref<Error | null> = ref(null);

export function useRiskProfileOptions() {

  const fetchOptions = async (force = false): Promise<void> => {
    if (options.value && !force) return;
    loading.value = true;
    error.value = null;
    try {
      const response = await apiEntries.accountAdmin.getKyxRiskModelOptions();
      options.value = response;
    } catch (err: any) {
      error.value = err;
    } finally {
      loading.value = false;
    }
  };

  onMounted(fetchOptions);

  return {
    options,
    loading,
    error,
    fetchOptions,
  };
}
